import { graphql } from '~/lib/graphql'

export const GetReserveInput = graphql(`
  query GetReserveInput(
    $restaurantId: RestaurantId!
    $planId: PlanId!
    $visitDate: Date!
    $visitTime: HourMinute!
    $visitorsCount: Int!
  ) {
    restaurant(restaurantId: $restaurantId) {
      plan(planId: $planId) {
        reserveInfo(
          input: { visitDate: $visitDate, visitTime: $visitTime, visitorsCount: $visitorsCount }
        ) {
          __typename
          ... on ReserveInfo {
            ...PlanReserveInfo
          }
          ... on ReserveInfoError {
            messages
          }
          ... on ReserveInfoRedirect {
            redirect
          }
        }
      }
      ...RestaurantMainInfoFragment
      ...RestaurantSubInfoFragment
    }
    viewer {
      ...ReserveInfoViewer
    }
  }
`)
